package dev.lingvo.shared.ops

import kotlinx.serialization.Serializable

@Serializable
data class OpsGrantCreditsRequest(
    val credits: Int,
    val reason: String,
    val note: String? = null,
    val period: String? = null,
    val requestId: String,
)

@Serializable
data class OpsGrantDto(
    val id: String,
    val credits: Int,
    val period: String,
    val note: String?,
    val createdAt: String,
    val alreadyGranted: Boolean,
    val creditsIncluded: Int,
    val creditsGranted: Int,
    val creditsUsed: Int,
    val grantHeadroom: Int,
)

@Serializable
data class OpsAgentBudgetDto(
    val liveAgents: Int,
    val maxCreditsPerCall: Int,
    val dailyBudget: Int,
    val monthlyBudget: Int,
)

@Serializable
data class OpsForceFailRequest(val reason: String)

@Serializable
data class OpsForceFailDto(
    val jobId: String,
    val state: OpsJobState,
    val done: Int,
    val total: Int,
    val reservedCredits: Int,
    val refundedCredits: Int,
    val creditsUsed: Int,
    val creditsRemaining: Int,
    val refundedPeriod: String?,
)

@Serializable
data class OpsForceFailPreviewDto(
    val refundCredits: Int,
    val refundPeriod: String,
    val deliveredStrings: Int,
    val totalStrings: Int,
)

@Serializable
data class OpsCronRunRequest(val reason: String)

@Serializable
data class OpsCronRunDto(
    val job: String,
    val affected: Int,
    val detail: String,
    val ranAt: String,
)

@Serializable
data class OpsRevokeCredentialsRequest(
    val reason: String,
    val confirmEmail: String,
    val note: String? = null,
)

@Serializable
data class OpsRevocationDto(
    val userId: String,
    val email: String,
    val sessions: Int,
    val apiTokens: Int,
    val agents: Int,
    val emailQueued: Boolean,
)

@Serializable
data class OpsLiveCredentialsDto(
    val sessions: Int,
    val apiTokens: Int,
    val agents: Int,
)
